import Styles from './Empty.module.scss'
import { BsBox2Fill } from "react-icons/bs";
import clsx from 'clsx';
function TableUserEmtyComponent(){
    return(
        <div className={clsx(Styles.mainWrap)}>
            <div className={clsx(Styles.tempyBox)}>
                <BsBox2Fill className={clsx(Styles.iconEmty)}/>
                <span className={clsx(Styles.titleEmty)}>Dữ Liệu Rỗng</span>
            </div>
        </div>
    )
}
export default TableUserEmtyComponent